import { render, staticRenderFns } from "./receiveDetail.vue?vue&type=template&id=01bb6b84&scoped=true"
import script from "./receiveDetail.vue?vue&type=script&lang=js"
export * from "./receiveDetail.vue?vue&type=script&lang=js"
import style0 from "./receiveDetail.vue?vue&type=style&index=0&id=01bb6b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb6b84",
  null
  
)

export default component.exports